import React from "react";
import { pipe } from "fp-ts/lib/function";
import { array } from "fp-ts";
import { TCasesSailHomesReportForm } from "../../../../../../domain/codecs/form/CasesForm";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { CRMParagraph } from "../../../Simple/CRMParagraph/CRMParagraph";
import { WeightBold } from "../../../WeightBold/WeightBold";
import { CRMDropdownColourComponent, ICRMDropdownColourOption } from "../../../CRMDropdownColourComponent/CRMDropdownColourComponent";
import { CRMInputCheckboxComponent } from "../../../CRMInputCheckboxComponent/CRMInputCheckboxComponent";

export const CRMSailHomesReportFilter = (props: React.PropsWithChildren<{
    form: TCasesSailHomesReportForm;
    onToggleUnderOffer: (value: boolean) => void;
    onToggleNeedsAction: (value: boolean) => void;
    onChangeAssignedTo: (assignedTo: string | null) => void;
}>): JSX.Element => {
    const { form } = props;

    const assignableOptions: Array<ICRMDropdownColourOption<string>> = pipe(
        form.children.assignable_users,
        array.map(({ id, first_name, last_name }) => ({
            label: `${first_name} ${last_name}`,
            value: id,
        })),
        array.prepend({ label: "Anyone", value: "any" }),
    );

    const showCount = form.status !== "submitting";

    return (
        <SpacingRow spacing={CRMSpacing.TINY}>
            <CRMParagraph>
                <WeightBold>Showing{showCount ? ` ${form.children.available_count.toLocaleString("en-GB")}` : ""} Sail Homes cases</WeightBold>
            </CRMParagraph>

            {/* NEEDS ACTION TODAY */}
            <CRMParagraph>
                <WeightBold>. Needs action today</WeightBold>
            </CRMParagraph>
            <CRMInputCheckboxComponent
                checked={form.edited.filters.needs_action_only}
                onClick={() => props.onToggleNeedsAction(!form.edited.filters.needs_action_only)}
            />

            {/* UNDER OFFER */}
            <CRMParagraph>, </CRMParagraph>
            <CRMParagraph>
                <WeightBold>under offer only</WeightBold>
            </CRMParagraph>
            <CRMInputCheckboxComponent
                checked={form.edited.filters.under_offer_only}
                onClick={() => props.onToggleUnderOffer(!form.edited.filters.under_offer_only)}
            />

            {/* ASSIGNEE */}
            <CRMParagraph>, </CRMParagraph>
            <CRMParagraph>
                <WeightBold>assigned to</WeightBold>
            </CRMParagraph>
            <CRMDropdownColourComponent
                value={form.edited.filters.assigned_to || "any"}
                options={assignableOptions}
                onChange={(value) => props.onChangeAssignedTo(value === "any" ? null : value)}
            />
        </SpacingRow>
    );
};
